// src/Pages/Landing/JoyrideLappeenrantaLanding.jsx
import React from "react";
import JoyrideKaupunkiLanding from "./JoyrideKaupunkiLanding.jsx";
import joyrideHero from "../../assets/Joyride_04.webp";

export default function JoyrideLappeenrantaLanding() {
  return (
    <JoyrideKaupunkiLanding
      city="Lappeenranta"
      maakunta="Etelä-Karjala"
      nearbyAreas={[
        "Imatra",
        "Taipalsaari",
        "Lemi",
        "Luumäki",
        "Savitaipale",
        "Ruokolahti"
      ]}
      cityText="Bilebändi Joyride tekee keikkoja Lappeenrannassa ja Etelä-Karjalan alueella tapahtuman luonteesta, aikataulusta ja matkasta riippuen. Lappeenranta sopii Bilebändi Joyridelle hyvin esimerkiksi häihin, yritysjuhliin, pikkujouluihin, syntymäpäiville ja kesäjuhliin, kun juhliin halutaan energinen livebändi."
      logisticsText="Lappeenrannan keikoissa kokonaisuus sovitaan aina tapahtumapaikan, aikataulun ja keikan keston mukaan. Bilebändi Joyridellä on oma kuljetus, oma äänentoisto ja valotekniikka, mikä helpottaa juhlan suunnittelua etenkin silloin, kun tapahtumapaikalla ei ole valmista tekniikkaa."
      bookingLink="/#varaa"
      heroImage={joyrideHero}
    />
  );
}